import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";
import styles from "./breadcrumbItem.module.scss";
import BreadcrumItemProps from './BreadcrumbItemProps';

const BreadcrumbItem = ({
  text,
  icon,
  to,
  children,
  active,
  onClick
}: BreadcrumItemProps) => {
  // sub-renders
  const renderLink = () => {
    if (to) {
      return (
        <Link to={to} className={styles.link} onClick={onClick}>
          {renderContent()}
        </Link>
      );
    } else {
      return (
        <span className={styles.link}>
          {renderContent()}
        </span>
      );
    }
  };

  const renderContent = () => {
    if (text || icon) {
      return (
        <>
          {renderIcon(text !== undefined)}
          {text}
        </>
      );
    } else {
      return <>{children}</>;
    }
  };
  
  const renderIcon = (includeMargin: boolean = false) => {
    if (icon) {
      return (
        <span className={includeMargin ? "mr-2" : undefined}>
          <FontAwesomeIcon icon={icon!} />
        </span>
      );     
    }
  }

  // render
  return (
    <li className={`breadcrumb-item ${styles.item}${active ? " active" : ""}`}>
      {renderLink()}
    </li>
  );
};

export default BreadcrumbItem;
